import React, { useState } from 'react';
import './CalculatorModal.css';

const CalculatorModal = ({ show, onClose }) => {
  const [expression, setExpression] = useState('');
  const [result, setResult] = useState('');

  if (!show) return null;

  const handleButtonClick = (value) => {
    if (value === 'AC') {
      setExpression('');
      setResult('');
    } else if (value === '=') {
      try {
        const evalResult = eval(expression);
        setResult(evalResult);
      } catch {
        setResult('Error');
      }
    } else if (value === 'Back') {
      setExpression((prev) => prev.slice(0, -1));
    } else {
      setExpression((prev) => prev + value);
    }
  };

  return (
    <div className="calc-modal-overlay" onClick={onClose}>
      <div className="calc-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="calc-close-btn" onClick={onClose}>✕</button>

        <div className="calc-display">
          <div className="calc-expression">{expression}</div>
          <div className="calc-result">{result}</div>
        </div>

        <div className="calc-grid">
          <button onClick={() => handleButtonClick('AC')} className="op-btn">AC</button>
          <button onClick={() => handleButtonClick('/')} className="op-btn">÷</button>
          <button onClick={() => handleButtonClick('*')} className="op-btn">×</button>
          <button onClick={() => handleButtonClick('Back')} className="op-btn back-btn">⌫</button>

          <button onClick={() => handleButtonClick('7')}>7</button>
          <button onClick={() => handleButtonClick('8')}>8</button>
          <button onClick={() => handleButtonClick('9')}>9</button>
          <button onClick={() => handleButtonClick('-')} className="op-btn">−</button>

          <button onClick={() => handleButtonClick('4')}>4</button>
          <button onClick={() => handleButtonClick('5')}>5</button>
          <button onClick={() => handleButtonClick('6')}>6</button>
          <button onClick={() => handleButtonClick('+')} className="op-btn">+</button>

          <button onClick={() => handleButtonClick('1')}>1</button>
          <button onClick={() => handleButtonClick('2')}>2</button>
          <button onClick={() => handleButtonClick('3')}>3</button>
          <button onClick={() => handleButtonClick('=')} className="equals-btn">=</button>

          <button onClick={() => handleButtonClick('0')} className="zero-btn">0</button>
          <button onClick={() => handleButtonClick('.')}>.</button>
        </div>
      </div>
    </div>
  );
};

export default CalculatorModal;
